import {
  Card,
  CardBody,
  Col,
  Container,
  Image,
  Row,
  Spinner,
} from "react-bootstrap";
import { BiSolidQuoteLeft } from "react-icons/bi";
import { SwiperSlide, Swiper } from "swiper/react";
import { primaryColor, textLightColor } from "../../../../Constants/Colors";
import { StarFill } from "react-bootstrap-icons";
import { useGetTestimonialDataQuery } from "../../../../redux/api/TestimonialApi/testimonialApi";
import { Autoplay } from "swiper/modules";

const Testimonial = () => {
  const { data, isLoading } = useGetTestimonialDataQuery({
    limit: 100, // Fetch a larger number for the landing page
    sortBy: "display_order",
    order: "asc",
  });

  const testimonials = data?.testimonials?.filter((t) => t.status) || [];

  if (isLoading) {
    return (
      <Container className="py-5 text-center">
        <Spinner animation="border" variant="primary" />
      </Container>
    );
  }

  if (testimonials.length === 0) return null;

  return (
    <Container>
      <div className="d-flex align-items-center mb-2">
        <small className="text-muted text-uppercase me-3">Testimonial</small>
        <div style={{ flex: 1, height: "2px", backgroundColor: "#ccc" }}></div>
      </div>
      <Row>
        <Col lg={6}>
          {" "}
          <h1 style={{ color: primaryColor }}>
            What Our Clients Say About Partnering With Ideal
          </h1>
        </Col>
        <Col lg={12}>
          <p>Real experiences. Real results.</p>
        </Col>
      </Row>

      <Swiper
        watchSlidesProgress={true}
        centeredSlides={true}
        loop={testimonials.length > 3}
        spaceBetween={10}
        modules={[Autoplay]}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        breakpoints={{
          0: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: testimonials.length < 3 ? testimonials.length : 3,
          },
        }}
        className="mySwiper testimonial-swiper py-5"
      >
        {testimonials.map((testimonial, index) => {
          return (
            <SwiperSlide key={testimonial.id || index}>
              <Card
                style={{
                  border: "none",
                  backgroundColor: primaryColor,
                  color: textLightColor,
                  cursor: "pointer",
                }}
                className="overflow-hidden"
              >
                <CardBody>
                  <BiSolidQuoteLeft
                    className="slider-quote"
                    color={textLightColor}
                  />
                  <p
                    style={{ fontSize: "14px" }}
                    className="testimonial-desc text-justify"
                  >
                    {testimonial.client_review}
                  </p>
                  <Row className="align-items-center d-flex">
                    <Col xs={3} lg={2}>
                      <Image
                        src={testimonial.client_image}
                        roundedCircle
                        className="testimonial-profilepic"
                        alt={testimonial.client_name}
                      ></Image>
                    </Col>
                    <Col xs={5} lg={6} className="testimonial-name ">
                      <h6>{testimonial.client_name}</h6>
                      <p className="d-block mb-0" style={{ fontSize: "12px" }}>
                        {testimonial.client_designation}
                      </p>
                    </Col>
                    <Col xs={4} className="d-flex align-items-center">
                      <div className="bg-light align-items-center d-flex p-1 p-lg-2 rounded-pill">
                        {[...Array(Number(testimonial.client_rating))].map(
                          (_, i) => (
                            <StarFill
                              key={i}
                              color="gold"
                              className="me-xl-1 star-rating"
                            />
                          ),
                        )}
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </Container>
  );
};

export default Testimonial;
